<template>
  <!-- 清运记录 -->
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <el-form-item label="社区">
          <el-input @keyup.enter.native="searchQuery" v-model="queryParam.wlCommunityName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="清运员">
          <el-input @keyup.enter.native="searchQuery" v-model="queryParam.wlUserName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="queryParam.type" placeholder="请选择">
            <el-option label value></el-option>
            <el-option label="清运记录" value="1"></el-option>
            <el-option label="过磅单" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="清运类型">
          <el-select v-model="queryParam.cleanType" placeholder="请选择">
            <el-option label value></el-option>
            <el-option label="村内清运" value="1"></el-option>
            <el-option label="外围偷倒清运" value="2"></el-option>
            <el-option label="台账清运" value="3"></el-option>
            <el-option label="其他清运" value="4"></el-option>
            <el-option label="分拣中心" value="5"></el-option>
            <el-option label="外运马坡" value="6"></el-option>
            <el-option label="社区清运" value="7"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="类型">
          <el-input @keyup.enter.native="searchQuery" v-model="queryParam.type" placeholder="请输入"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="清运类型">
          <el-input @keyup.enter.native="searchQuery" v-model="queryParam.cleanType" placeholder="请输入"></el-input>
        </el-form-item> -->
        <div class="selectBox">
          <span class="selectText">提交日期</span>
          <el-date-picker
            size="mini"
            v-model="inspectionDate"
            @change="dateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
          <el-button
            style="margin-left: 10px"
            type="primary"
            @click="exportXls('清运记录列表', url.exportXlsUrl)"
            >导出清运列表</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #cleanType="slotData">
        <p v-if="slotData.data.row.cleanType == 1">村内清运</p>
        <p v-if="slotData.data.row.cleanType == 2">外围偷倒清运</p>
        <p v-if="slotData.data.row.cleanType == 3">台账清运</p>
        <p v-if="slotData.data.row.cleanType == 4">其他清运</p>
        <p v-if="slotData.data.row.cleanType == 5">分拣中心</p>
        <p v-if="slotData.data.row.cleanType == 6">外运马坡</p>
        <p v-if="slotData.data.row.cleanType == 7">社区清运</p>
      </template>
      <template #type="slotData">
        <p v-if="slotData.data.row.type == 1">清运记录</p>
        <p v-if="slotData.data.row.type == 2">过磅单</p>
      </template>
      <template #photo="slotData">
        <el-image
          v-if="slotData.data.row.weighingListPhoto"
          style="width: 100px; height: 50px"
          :src="slotData.data.row.weighingListPhoto[0]"
          :preview-src-list="[slotData.data.row.weighingListPhoto[0]]"
          :key="slotData.data.row.id"
        >
          <div slot="error" class="image-slot" style="width: 100px; height: 50px">
            <img src="@/assets/imgFail.png" alt style="width: 60px; height: 40px" />
          </div>
        </el-image>
        <span style="color: gray" v-else>暂无</span>
      </template>
      <template #handlerSlot="slotData">
        <el-button size="mini" @click="handleDetail(slotData.data.row)">详情</el-button>
      </template>
    </e-table>
    <detailModal :cleanDetail="cleanDetail" ref="detailModal"></detailModal>
  </div>
</template>

<script>
import { httpAction } from '@/api/manage'
import detailModal from './component/detailModal.vue'

import eTable from '@/components/table'
import { listMixin } from '@/mixins/listMixin'
export default {
  components: { eTable, detailModal },
  mixins: [listMixin],
  props: {},
  mounted () {
    this.dateDefaultShow = new Date()
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1)
  },
  data () {
    return {
      inspectionDate: "",
      dateDefaultShow: "",
      expireTimeOption: {
        disabledDate (date) {
          return date.getTime() >= Date.now()
        },
      },
      deleteKey: 'userId',
      url: {
        list: '/wlCleanRecord/page',
        exportXlsUrl: '/wlCleanRecord/exportCleanStatistics',
      },

      //字段权限
      columns: [
        {
          field: 'wlCommunityName',
          label: '社区',
        },
        {
          field: 'wlUserName',
          label: '清运员',
        },
        {
          field: 'pointPositionName',
          label: '点位',
        },
        {
          field: 'type',
          label: '类型',
          slotName: 'type',
          columnType: 'slot',
        },
        {
          field: 'cleanType',
          label: '清运类型',
          slotName: 'cleanType',
          columnType: 'slot',
        },
        {
          field: 'createTime',
          label: '提交时间',
        },
        {
          field: 'netWeight',
          label: '净重(kg)',
        },
        {
          width: 200,
          label: "过磅单照片",
          slotName: "photo",
          columnType: "slot",
        },
        {
          width: 260,
          label: '编辑',
          slotName: 'handlerSlot',
          columnType: 'slot',
        },
      ],
      cleanDetail: {}
    }
  },
  watch: {},
  computed: {},
  methods: {
    exportXls (name, url) {
      if (!this.queryParam.createTimeStart && !this.queryParam.createTimeEnd) return this.$message.warning("请选择提交日期后导出")
      this.handleExportXls(name, url)
    },
    dateChange (date) {
      if (date) {
        this.queryParam.createTimeStart = date[0] + " 00:00:00"
        this.queryParam.createTimeEnd = date[1] + " 23:59:59"
      } else {
        this.queryParam.createTimeStart = ''
        this.queryParam.createTimeEnd = ''
      }
    },
    searchReset () {
      this.queryParam = {
      }
      this.inspectionDate = ""
      this.searchQuery()
    },
    async handleDetail (row) {
      this.cleanDetail = {}
      this.$refs.detailModal.add()
      let res = await httpAction(`/wlCleanRecord/detail/${row.id}`, {}, 'get')
      if (res.code !== 200) return this.$message.warning(res.msg)
      this.cleanDetail = res.data
    },
    fetchData () {
      console.log(this.ipagination.page)
    },
    add (val) {
      console.log(val)
    },
    edit (val) { },
    del (val) { },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
